export interface ServiceProviderAccount {
    id: string;
    account_id: string;
    source_account_id: string;
    source_account_name: string;
    source_account_friendly_identifier: string;
    role?: string; // mock role for this CertCentral instance (shown in the side rail)
  }
  
  export interface Application {
    id: string;
    name: string;
    app_code: string;
    icon: string;
    description: string;
    service_provider_accounts?: ServiceProviderAccount[];
    roles?: string[]; // mock roles shown as chips in the side rail
  }
  
  export interface Environment {
    id: string; // mock environment ID shown in the side rail "Environment ID" field
    name: string;
    region: string;
    url: string;
    applications: Application[];
  }
  
  const SHARED_SPA: ServiceProviderAccount[] = [
    {
      id: '4366373f-18e4-4546-977e-cc52c937aa03',
      account_id: '741f9818-4d01-465f-b21e-f4a4088bae65',
      source_account_id: 'ac0d56bd-96d2-426e-ad4e-acd90761c834',
      source_account_name: 'security Issue account',
      source_account_friendly_identifier: '9065059',
    },
  ];
  
  export const ENVIRONMENTS_MOCK: Environment[] = [
    {
      id: '987hjk6543hk123',
      name: 'Acme — US production',
      region: 'US',
      url: 'https://www.portal.digicert.com/xyz',
      applications: [
        {
          id: '45bb1021-ec0f-45ea-9beb-d9bf9da3813f',
          name: 'Software Trust',
          app_code: 'stm.local.us',
          icon: 'stIcon',
          description: 'Software Trust Manager Application',
          service_provider_accounts: SHARED_SPA,
        },
        {
          id: '6582198b-4dc4-4a16-9087-ebe50c0e3972',
          name: 'Trust Lifecycle',
          app_code: 'tlm.local.us',
          icon: 'tlIcon',
          description: 'Trust Lifecycle',
          service_provider_accounts: SHARED_SPA,
        },
        {
          id: 'a4c9c19b-4930-47cc-b3fd-3bd134277d9a',
          name: 'Content Trust',
          app_code: 'dtm.local.us',
          icon: 'ctIcon',
          description: 'Content Trust Manager Application',
          service_provider_accounts: SHARED_SPA,
        },
        {
          id: 'aebfc552-4ed8-11f1-b66f-8a0042dee6f3',
          name: 'DigiCert DNS',
          app_code: 'dnstrust.local.us',
          icon: 'dnsTrustIcon',
          description: 'DigiCert DNS',
        },
        {
          id: 'aedb2223-4ed8-11f1-b66f-8a0042dee6f3',
          name: 'Private CA',
          app_code: 'cm.local.us',
          icon: 'caIcon',
          description: 'Private CA Application',
          service_provider_accounts: SHARED_SPA,
        },
        {
          id: 'aedee708-4ed8-11f1-b66f-8a0042dee6f3',
          name: 'Device Trust',
          app_code: 'devctm.local.us',
          icon: 'devctmIcon',
          description: 'Device Trust Manager Application',
          service_provider_accounts: SHARED_SPA,
        },
        {
          id: 'cf3b826b-e276-428e-8019-2a4c7e526628',
          name: 'IoT Trust',
          app_code: 'iot.local.us',
          icon: 'iotIcon',
          description: 'IoT Trust Manager Application',
          service_provider_accounts: SHARED_SPA,
        },
        {
          id: 'ff311b29-7fd9-4f20-8543-a676b6198642',
          name: 'CertCentral',
          app_code: 'cc.local.us',
          icon: 'ccIcon',
          description: 'CertCentral',
        },
      ],
    },
    {
      id: 'us-stage-abc123def',
      name: 'Acme — US stage',
      region: 'US',
      url: 'https://stage.portal.digicert.com/xyz',
      applications: [
        {
          id: 'b1a2c3d4-0001-0001-0001-000000000001',
          name: 'CertCentral',
          app_code: 'cc.local.us',
          icon: 'ccIcon',
          description: 'CertCentral',
          service_provider_accounts: [
            { ...SHARED_SPA[0], id: 'spa-stage-us-1' },
            { ...SHARED_SPA[0], id: 'spa-stage-us-2', source_account_name: 'Stage account EU', source_account_friendly_identifier: '9065060' },
            { ...SHARED_SPA[0], id: 'spa-stage-us-3', source_account_name: 'Stage account EU 2', source_account_friendly_identifier: '9065061' },
          ],
        },
        {
          id: 'b1a2c3d4-0001-0001-0001-000000000002',
          name: 'Private CA',
          app_code: 'cm.local.us',
          icon: 'caIcon',
          description: 'Private CA Application',
          service_provider_accounts: SHARED_SPA,
        },
        {
          id: 'b1a2c3d4-0001-0001-0001-000000000003',
          name: 'DigiCert DNS',
          app_code: 'dnstrust.local.us',
          icon: 'dnsTrustIcon',
          description: 'DigiCert DNS',
        },
        {
          id: 'b1a2c3d4-0001-0001-0001-000000000004',
          name: 'Software Trust',
          app_code: 'stm.local.us',
          icon: 'stIcon',
          description: 'Software Trust Manager Application',
          service_provider_accounts: SHARED_SPA,
        },
        {
          id: 'b1a2c3d4-0001-0001-0001-000000000005',
          name: 'Trust Lifecycle',
          app_code: 'tlm.local.us',
          icon: 'tlIcon',
          description: 'Trust Lifecycle',
          service_provider_accounts: SHARED_SPA,
        },
      ],
    },
    {
      id: 'eu-prod-xyz789abc',
      name: 'Acme — EU production',
      region: 'EU',
      url: 'https://eu.portal.digicert.com/xyz',
      applications: [
        {
          id: 'c2b3d4e5-0002-0002-0002-000000000001',
          name: 'CertCentral',
          app_code: 'cc.local.eu',
          icon: 'ccIcon',
          description: 'CertCentral',
          service_provider_accounts: [
            { ...SHARED_SPA[0], id: 'spa-eu-prod-1', source_account_name: 'EU Prod account', source_account_friendly_identifier: '9065062' },
          ],
        },
        {
          id: 'c2b3d4e5-0002-0002-0002-000000000002',
          name: 'Private CA',
          app_code: 'cm.local.eu',
          icon: 'caIcon',
          description: 'Private CA Application',
          service_provider_accounts: SHARED_SPA,
        },
        {
          id: 'c2b3d4e5-0002-0002-0002-000000000003',
          name: 'DigiCert DNS',
          app_code: 'dnstrust.local.eu',
          icon: 'dnsTrustIcon',
          description: 'DigiCert DNS',
        },
        {
          id: 'c2b3d4e5-0002-0002-0002-000000000004',
          name: 'Software Trust',
          app_code: 'stm.local.eu',
          icon: 'stIcon',
          description: 'Software Trust Manager Application',
          service_provider_accounts: SHARED_SPA,
        },
        {
          id: 'c2b3d4e5-0002-0002-0002-000000000005',
          name: 'Trust Lifecycle',
          app_code: 'tlm.local.eu',
          icon: 'tlIcon',
          description: 'Trust Lifecycle',
          service_provider_accounts: SHARED_SPA,
        },
      ],
    },
    {
      id: 'eu-stage-lmn456opq',
      name: 'Acme — EU stage',
      region: 'EU',
      url: 'https://eu-stage.portal.digicert.com/xyz',
      applications: [
        {
          id: 'd3c4e5f6-0003-0003-0003-000000000001',
          name: 'CertCentral',
          app_code: 'cc.local.eu',
          icon: 'ccIcon',
          description: 'CertCentral',
          service_provider_accounts: [
            { ...SHARED_SPA[0], id: 'spa-eu-stage-1', source_account_name: 'EU Stage account US', source_account_friendly_identifier: '9065063' },
            { ...SHARED_SPA[0], id: 'spa-eu-stage-2', source_account_name: 'EU Stage account EU', source_account_friendly_identifier: '9065064' },
          ],
        },
        {
          id: 'd3c4e5f6-0003-0003-0003-000000000002',
          name: 'Private CA',
          app_code: 'cm.local.eu',
          icon: 'caIcon',
          description: 'Private CA Application',
          service_provider_accounts: SHARED_SPA,
        },
        {
          id: 'd3c4e5f6-0003-0003-0003-000000000003',
          name: 'DigiCert DNS',
          app_code: 'dnstrust.local.eu',
          icon: 'dnsTrustIcon',
          description: 'DigiCert DNS',
        },
        {
          id: 'd3c4e5f6-0003-0003-0003-000000000004',
          name: 'Software Trust',
          app_code: 'stm.local.eu',
          icon: 'stIcon',
          description: 'Software Trust Manager Application',
          service_provider_accounts: SHARED_SPA,
        },
        {
          id: 'd3c4e5f6-0003-0003-0003-000000000005',
          name: 'Trust Lifecycle',
          app_code: 'tlm.local.eu',
          icon: 'tlIcon',
          description: 'Trust Lifecycle',
          service_provider_accounts: SHARED_SPA,
        },
      ],
    },
    {
      id: 'in-prod-rst321uvw',
      name: 'Acme — IN',
      region: 'IN',
      url: 'https://in.portal.digicert.com/xyz',
      applications: [
        {
          id: 'e4d5f6a7-0004-0004-0004-000000000001',
          name: 'CertCentral',
          app_code: 'cc.local.in',
          icon: 'ccIcon',
          description: 'CertCentral',
          service_provider_accounts: [
            { ...SHARED_SPA[0], id: 'spa-in-1', source_account_name: 'IN account EU', source_account_friendly_identifier: '9065065' },
          ],
        },
        {
          id: 'e4d5f6a7-0004-0004-0004-000000000002',
          name: 'DigiCert DNS',
          app_code: 'dnstrust.local.in',
          icon: 'dnsTrustIcon',
          description: 'DigiCert DNS',
        },
      ],
    },
    {
      id: 'nl-prod-ghi654jkl',
      name: 'Acme — NL',
      region: 'NL',
      url: 'https://nl.portal.digicert.com/xyz',
      applications: [
        {
          id: 'f5e6a7b8-0005-0005-0005-000000000001',
          name: 'Private CA',
          app_code: 'cm.local.nl',
          icon: 'caIcon',
          description: 'Private CA Application',
          service_provider_accounts: SHARED_SPA,
        },
        {
          id: 'f5e6a7b8-0005-0005-0005-000000000002',
          name: 'Software Trust',
          app_code: 'stm.local.nl',
          icon: 'stIcon',
          description: 'Software Trust Manager Application',
          service_provider_accounts: SHARED_SPA,
        },
        {
          id: 'f5e6a7b8-0005-0005-0005-000000000003',
          name: 'Trust Lifecycle',
          app_code: 'tlm.local.nl',
          icon: 'tlIcon',
          description: 'Trust Lifecycle',
          service_provider_accounts: SHARED_SPA,
        },
      ],
    },
  ];

  // ── Dummy roles ──
  // Roles are not yet returned by the API, so they are injected here for the side rail.
  // App roles render as chips; each CertCentral instance gets a single cycling role.
  const APP_ROLE_MAP: Record<string, string[]> = {
    'Private CA': ['Administrator'],
    'DigiCert DNS': ['Viewer'],
    'Software Trust': ['Team lead', 'Developer'],
    'Trust Lifecycle': ['Infrastructure admin', 'Certificate profile manager'],
    'Content Trust': ['Content publisher', 'Reviewer'],
    'Device Trust': ['Device manager'],
    'IoT Trust': ['IoT operator'],
  };

  const SPA_ROLE_CYCLE = ['Finance manager', 'Manager', 'Standard user'];

  ENVIRONMENTS_MOCK.forEach((env) => {
    env.applications.forEach((app) => {
      if (app.roles === undefined && APP_ROLE_MAP[app.name]) {
        app.roles = APP_ROLE_MAP[app.name];
      }
      app.service_provider_accounts = app.service_provider_accounts?.map((spa, i) => ({
        ...spa,
        role: spa.role ?? SPA_ROLE_CYCLE[i % SPA_ROLE_CYCLE.length],
      }));
    });
  });